import AppCopy from "copy/AppCopy";
import { CarCardProps } from "declarations/card";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCar } from "reducers/carReducer";
import { Paths } from "router/Paths";
import { CarStatusType } from "types/loadedData";

function LiveCarStaffCard({ car }: CarCardProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { carNoText, assignedText, CustomerText, statusText } =
    AppCopy.oneStaffPage;

  const status = car.status;

  const statusTagColor = (carStatus: CarStatusType): string => {
    switch (carStatus) {
      case "Assigned":
        return Classname.statusTagAssigned;
      case "Cancelled":
        return Classname.statusTagCancelled;
      case "Rented":
        return Classname.statusTagRented;
      case "Sold":
        return Classname.statusTagSold;
      default:
        return "";
    }
  };

  const statusBorderColor = (carStatus: CarStatusType): string => {
    switch (carStatus) {
      case "Assigned":
        return Classname.statusContainerAssigned;
      case "Cancelled":
        return Classname.statusContainerCancelled;
      case "Rented":
        return Classname.statusContainerRented;
      case "Sold":
        return Classname.statusContainerSold;
      default:
        return "";
    }
  };

  const handleDetails = () => {
    dispatch(setCar(car));
    navigate(`${Paths.cars}/${car._id}`);
  };

  const handleOnClickStaff = () => {
    navigate(`${Paths.staff}/${car.assigned?._id}`);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.carNo} onClick={handleDetails}>
        <span className={Classname.title}>{carNoText}</span>
        <span className={Classname.carTag}>
          {car.tag}
          <span className={Classname.carTagBold}>
            {car.listingType === "Rent" ? "R" : "S"}
          </span>{" "}
        </span>
      </div>
      <div className={Classname.asigned} onClick={handleOnClickStaff}>
        <span className={Classname.title}>{assignedText}</span>
        <span>{car.assigned?.name}</span>
      </div>
      <div className={Classname.status}>
        <span className={Classname.title}>{statusText}</span>
        <div className={Classname.statusContent}>
          <div
            className={`${Classname.statusTagContainer} ${statusBorderColor(
              status
            )}`}
          >
            <div
              className={`${Classname.statusTag} ${statusTagColor(status)}`}
            ></div>
          </div>
          <span>{status}</span>
        </div>
      </div>
      <div className={Classname.customer}>
        <span className={Classname.title}>{CustomerText}</span>
        <span>{car.buyerName}</span>
      </div>
    </div>
  );
}

export default LiveCarStaffCard;

const Classname = {
  container:
    "w-full border-b flex flex-wrap sm:flex-nowrap items-center justify-between text-base text-secondaryText sm:h-14 flex-shrink-0",
  carNo: "w-32 sm:w-1/5 cursor-pointer",
  asigned: "w-32 sm:w-1/5 text-blue my-2 sm:my-0 cursor-pointer",
  status: "w-32 sm:w-1/5 flex flex-col my-2 sm:my-0 ",
  customer: "w-32 sm:w-1/5 flex flex-col sm:justify-end my-2 sm:my-0 ",

  title: "flex sm:hidden my-2 text-xs text-secondaryText",

  carTag:
    "flex items-center justify-center w-20 bg-bgSecondary rounded-md text-primaryText",
  carTagBold: "font-bold",
  statusTagContainer:
    "w-4 h-4 rounded-full flex items-center justify-center border",
  statusTag: "w-3 h-3 rounded-full",
  statusContent: "flex items-center gap-4",

  statusContainerAssigned: "border-statusAssigned",
  statusContainerCancelled: "border-statusCancelled",
  statusContainerRented: "border-statusRented",
  statusContainerSold: "border-statusSold",

  statusTagAssigned: "bg-statusAssigned",
  statusTagCancelled: "bg-statusCancelled",
  statusTagRented: "bg-statusRented",
  statusTagSold: "bg-statusSold",

  detailsButton: "bg-blue text-white p-1 rounded-md px-3",
};
